import '@vitejs/plugin-react/preamble';
// CSS
import '@simwood/nv-react-components/styles.css';
import 'normalize.css';

import {
  authService,
  NvAlertProvider,
  nvStorage,
  NvThemeProvider,
} from '@simwood/nv-react-components';

nvStorage.registerPrefix('nv');

// FIXMEreplace Hammer and delete prop-types

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import RootGuard from '../shared/components/RootGuard';
import { initCspViolationReporting } from '../shared/helpers/cspReporting';
import { restAPIBase } from '../shared/helpers/nvFetch';
import App from './components/App';
import store from './store/index';
import { initStoreListeners } from './store/initListeners';

// eslint-disable-next-line no-console
console.log(
  `%c v${version}-${buildId} `,
  'background: #e0ebeb; color: #262626;',
);

initStoreListeners();
initCspViolationReporting();

document.title = 'Communicator';
const container = document.getElementById('root');
const root = createRoot(container!);

const render = () => {
  root.render(
    <Provider store={store}>
      <NvThemeProvider>
        <NvAlertProvider>
          <RootGuard>
            <App />
          </RootGuard>
        </NvAlertProvider>
      </NvThemeProvider>
    </Provider>,
  );
};

if (
  process.env.NODE_ENV === 'development' &&
  window.location.pathname === '/auth/callback'
) {
  const searchParams = Object.fromEntries(
    new URLSearchParams(window.location.search),
  );

  authService.handleOauthCallback(
    restAPIBase(),
    searchParams.code,
    () => {
      window.location.replace(window.location.origin);
    },
    (err) => {
      console.error(err);
      render();
    },
    1,
  );
} else {
  render();
}
